import { Module } from "types/type.module";

/*
  @function interpretStep
  renders step from module
  @param id {string} - id of step
  @param module {object} - module to find step
 */
function interpretStep(id: any, module: Module) {
  const chapter = id.chapterPos;
  const questionId = id.questionPos;
  const question = module.chapters[chapter].questions[questionId];

  return {
    title: {
      text:
        typeof question.content === "string"
          ? JSON.parse(question.content)
          : question.content,
      guide: [...question.guidances]
        .sort((a, b) => a.order_number - b.order_number)
        .map((g) => {
          if (typeof g.content === "string") {
            return JSON.parse(g.content).text;
          } else {
            return g.content.text;
          }
        }),
      example: [...question.examples]
        .sort((a, b) => a.order_number - b.order_number)
        .map((e) => {
          if (typeof e.content === "string") {
            return JSON.parse(e.content).text;
          } else {
            return e.content.text;
          }
        }),
    },
    id: id,
    multiple: question.multiple ? ("multiple" as const) : ("single" as const),
    answers: extractAnswers(question.possible_answers),
    conclusion: question.conclusion,
    print: question.print,
  };
}

/**
   @function extractAnswers
   extract answers from answers module
   @param answers {object} - answers directly from module
   @returns {array}
 */

function extractAnswers(answers: any) {
  const result: Array<{
    example: any;
    guide: any;
    id: any;
    label: any;
    order_number: any;
    single: any;
  }> = [];
  answers.forEach((answer: any) => {
    result.push({
      label: JSON.parse(answer.content).text,
      id: answer.possible_answer_id,
      guide: [...answer.guidances]
        .sort((a, b) => a.order_number - b.order_number)
        .map((g) => JSON.parse(g.content).text),
      example: [...answer.examples]
        .sort((a, b) => a.order_number - b.order_number)
        .map((g) => JSON.parse(g.content).text),
      order_number: answer["order_number"],
      single: answer.single,
    });
  });
  result.sort(
    (current, next) => current["order_number"] - next["order_number"]
  );

  return result;
}

export default interpretStep;
